import { useEffect, useRef, useState } from "react";

import * as Material from "@mui/material";

import ConfigLoader from "../../components/ConfigLoader";
import Popper from "@fragments/Popper";
import { Table, Button, Input, Text } from "@fragments";


import './styles.css'

import api from '@helpers/api'

import CustomModal from "@components/CustomModal";

import { IconDotsVertical, IconFocus2, IconPlus, IconSettings, IconTrash } from "@tabler/icons-react";

import { useCommunity } from "contexts/community";

import { useParams } from "react-router-dom";


import fb from "@assets/logo/partners/facebook.png";
import ga from "@assets/logo/partners/ga.png";
import gtm from "@assets/logo/partners/gtm.svg";
import ginasteeLogo from '@assets/logo/square-small-icon.svg'

const providers = [
    {
        identity: "facebook",
        label: "Facebook Pixel",
        icon: fb,
    },
    {
        identity: "hosted",
        label: "Ginastee",
        icon: ginasteeLogo,
    },
    {
        identity: "google_analytics",
        label: "Google Analytics",
        icon: ga,
    },
    {
        identity: "google_tag_manager",
        label: "Google Tag Manager",
        icon: gtm,
    },
];

export default function Pixels({ info, handleRefresh }) {
    const [loading, setLoading] = useState(true)

    let { slug } = useParams();

    const [currentCommunity, setCurrentCommunity] = useState()

    const { loading: communityLoading, community, loadCommunities } = useCommunity();

    const REF_config = useRef()
    const REF_configPixelModal = useRef()

    const popperRef = useRef()


    useEffect(() => {
        if (!communityLoading) handleLoad()
    }, [communityLoading])

    async function handleLoad() {

        if (info) {
            REF_config.current = { ...info }
            setCurrentCommunity({ ...info })
            setLoading(false)
        }
    }

    function handleConfigurePixel(pixel = null) {
        if (!pixel) {
            pixel = {
                community: info?.id,
                provider: {
                    id: "facebook",
                    pixel: "",
                },
            }
        }
        REF_configPixelModal.current.open(pixel, async function (result) {
            handleRefresh()
        })
    }

    function handleDeletePixel(id) {
        window.openConfirm({
            title: "Deletar pixel",
            headline: "Atenção!",
            subtitle: "Você realmente deseja apagar permanentemente este pixel?",
            buttons: [
                {
                    text: "Apagar permanentemente",
                    onClick: handleExecuteDelete,
                    variant: "contained",
                    className: "",
                    color: "error",
                },
                {
                    text: "Manter pixel",
                    variant: "text",
                },
            ],
        });

        async function handleExecuteDelete() {
            try {
                const { data } = await api.delete('community/pixel?id=' + id)
                if (data.success) {
                    window.setSnackbar('Pixel deletado com sucesso')
                    handleRefresh()
                } else {
                    window.setSnackbar('Para deletar um pixel, você precisa ser o proprietário da comunidade')
                }
            } catch (e) {
                console.log(e)
            }
        }
    }

    function handleOpenPixelOptions(event, pixel) {
        const options = [
            {
                id: 'configure',
                label: 'Configurar',
                icon: <IconSettings size={16} />,
                onClick: async () => {
                    handleConfigurePixel(pixel);
                    popperRef.current.close();
                }
            },
            {
                id: 'delete',
                label: 'Excluir pixel',
                icon: <IconTrash size={16} />,
                variant: 'danger',
                onClick: async () => {
                    handleDeletePixel(pixel.id);
                    popperRef.current.close();
                }
            }
        ];

        popperRef.current.open(options, 'bottom', event.currentTarget);
    }

    const columns = [
        {
            title: "Status",
            width: "60px",
            align: "center",
            customRender: (item) => item.active && <div className="live-indicator" />
        },
        {
            title: "Provedor",
            width: "250px",
            customRender: (item) => {
                const config = getProvider(item.provider.id);
                return (
                    <div className="plan-config-row">
                        <img src={config.icon} className="pixel-icon" style={{ width: 22, height: 22, marginRight: 8 }} />
                        <Text.span contrast={6}>{config.label}</Text.span>
                    </div>
                );
            }
        },
        {
            title: "Identificação",
            grow: 1,
            customRender: (item) => <Text.span contrast={6}>{item.provider.pixel}</Text.span>
        }
    ];

    function CreatePixelButton() {
        return (
            <Button
                onClick={() => handleConfigurePixel()}
                endIcon={<IconPlus />}
                text="Instalar pixel"
            />
        )
    }


    return (
        <div className="config-page config-general-community config-plans-page" key={loading}>
            {(loading || communityLoading) ? <ConfigLoader /> : (
                <div className="mt-4" key={Math.random()}>
                    <div className="px-3">
                        <Text.h3
                            grow
                            left={<IconFocus2 />}
                            right={<CreatePixelButton />}
                            value="Pixels de conversão"
                            className="mb-2"
                        />
                    </div>


                    <Table
                        id="community-pixels-table"
                        columns={columns}
                        data={currentCommunity?.pixels || []}
                        loading={loading}
                        fullWidth
                        actionsComponent={(item) => {
                            const disabledEdition = item.provider.id === "hosted";
                            if (disabledEdition) return null;
                            return (
                                <div className="plan-config-row" style={{ gap: '8px', justifyContent: 'flex-end', width: '100%' }}>
                                    <span
                                        className="plan-row-btn"
                                        onClick={() => handleConfigurePixel(item)}
                                        title="Configurar"
                                    >
                                        <IconSettings size={16} />
                                    </span>
                                    <span
                                        className="plan-row-btn"
                                        onClick={(event) => handleOpenPixelOptions(event, item)}
                                        title="Mais opções"
                                    >
                                        <IconDotsVertical size={16} />
                                    </span>
                                </div>
                            );
                        }}
                    />
                </div>
            )}

            <Popper controlRef={popperRef} />

            <PixelConfigModal modalRef={REF_configPixelModal} />
        </div >
    )
}



function getProvider(code) {
    return providers.find(p => p.identity === code);
}



function PixelConfigModal({ modalRef }) {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const [error, setError] = useState();

    const [provider, setProvider] = useState("facebook");
    const [id, setId] = useState("");

    const REF_config = useRef({});
    const REF_callback = useRef();

    modalRef.current = {
        open(pixel, callback = () => { }) {
            REF_config.current = { ...pixel };
            REF_callback.current = callback;
            console.log('Config pixel', pixel);
            setError(null);
            setId(pixel?.provider?.pixel || "");
            setProvider(pixel?.provider?.id || "facebook");
            setOpen(true);
        },
    };

    function handleChangeProvider(value) {
        setProvider(value);
    }
    async function handleSubmit() {
        try {
            const valid = isValid();

            if (!valid) {
                setError("Insira um id válido para o pixel");
                return;
            } else {
                setError(null);
            }

            setLoading(true);

            const { data } = await api.post("community/pixel", {
                community: REF_config.current.community,
                provider: {
                    id: provider,
                    pixel: id,
                },
            });

            if (!data.id) {
                setError("Um erro ocorreu ao salvar o pixel");
            } else {
                REF_callback.current(data);
                setOpen(false);
            }
        } catch (e) {
            setError("Houve um erro ao salvar o pixel");
            console.log(e);
        }

        setLoading(false);

        function isValid() {
            if (typeof id !== "string" || id.trim() === "") return false;

            switch (provider) {
                case "facebook":
                    return /^[0-9]{5,20}$/.test(id); // Facebook Pixel ID: geralmente número
                case "google_analytics":
                    return /^(UA-\d{4,9}-\d{1,4}|G-\w+)$/.test(id); // GA ID: tipo UA-XXXXX-Y ou G-XXXX
                case "google_tag_manager":
                    return /^GTM-[A-Z0-9]+$/.test(id); // GTM ID: tipo GTM-XXXX
                default:
                    return false;
            }
        }
    }

    return (
        <>
            <CustomModal
                maxWidth={360}
                bottomButtonCancelText="Cancelar"
                loading={loading}
                title="Instalar pixel"
                open={open}
                handleSubmit={handleSubmit}
                bottomButtonSumbitText="Concluir instalação"
                handleClose={() => setOpen(false)}
                bodyComponent={
                    open ? (
                        <div className="px-4 pt-4">
                            <Input.Select
                                value={provider}
                                onInput={handleChangeProvider}
                                label="Provedor"
                                placeholder="Selecione um provedor"
                                options={providers
                                    .filter(p => p.identity !== 'hosted')
                                    .map(p => ({
                                        value: p.identity,
                                        label: p.label,
                                        icon: <img src={p.icon} alt={p.label} className="select-pixel-provider-icon" />
                                    }))}
                                className="select-pixel-provider"
                            />

                            <Input
                                placeholder=""
                                autoFocus={true}
                                value={id}
                                onInput={setId}
                                label="Id do pixel"
                                className="mt-2"
                            />

                            {error && (
                                <Material.Alert className="mt-2" severity="error">
                                    {error}
                                </Material.Alert>
                            )}
                        </div>
                    ) : null
                }
            />
        </>
    );
}